import moment from 'moment-timezone';
import 'moment/locale/es';

const BOGOTA = 'America/Bogota';

/** Fecha de cita guardada en UTC → moment en hora Colombia para mostrar al usuario. */
export const parseAppointmentDate = (date) => {
    if (!date) return moment.invalid();
    return moment.utc(date).tz(BOGOTA);
};

/** Valor de input datetime-local (hora Colombia) → ISO UTC para guardar en la API. */
export const toAppointmentUTC = (datetimeLocal) => {
    if (!datetimeLocal) return null;
    return moment.tz(datetimeLocal, BOGOTA).utc().toISOString();
};

/** Texto legible de fecha de cita en español (Colombia). */
export const formatAppointmentDateDisplay = (date) => {
    const m = parseAppointmentDate(date);
    if (!m.isValid()) return '';
    moment.locale('es');
    const raw = m.format('dddd, D [de] MMMM [de] YYYY');
    return raw.charAt(0).toUpperCase() + raw.slice(1);
};

/** Hora de cita en formato 12h (Colombia). */
export const formatAppointmentTimeDisplay = (date) => {
    const m = parseAppointmentDate(date);
    if (!m.isValid()) return '';
    return m.format('h:mm A');
};

/** ISO UTC desde fecha YYYY-MM-DD + hora HH:mm en Colombia. */
export const colombiaSlotToUTC = (dateKey, timeStr) => {
    if (!dateKey || !timeStr) return null;
    const parts = String(timeStr).trim().split(':');
    const h = Number(parts[0]);
    const min = Number(parts[1] || 0);
    if (Number.isNaN(h) || Number.isNaN(min)) return null;
    const normalizedTime = `${String(h).padStart(2, '0')}:${String(min).padStart(2, '0')}`;
    const m = moment.tz(`${dateKey} ${normalizedTime}`, 'YYYY-MM-DD HH:mm', BOGOTA);
    return m.isValid() ? m.utc().toISOString() : null;
};

export default parseAppointmentDate;
